module.exports = __webpack_public_path__ + "static/media/info-white.e5dfd04e.svg";